import {
  apiRequest,
  commonRequestInstanceToAxiosRequestInfo,
} from '@/common/api/api.service'
import { API_BASE_URL, HTTP_METHOD_POST } from '@/common/constant'
import utils from '@/common/util/utils'

export const postEventApply = async ({ eventId }) => {
  const url = `${API_BASE_URL}/events/${eventId}/apply`
  // NOTE: 안드로이드 이벤트 상세 진입 시 잘못된 credential을 전달 (인코딩 이슈)
  // 앱쪽에서 수정 진행중이나 앱 업데이트가 필요하므로 웹에서 임시 처리 (크리덴셜 내 공백을 +로 replace)
  // 앱 업데이트 유저가 일정 비율을 넘어가면 해당 내용 삭제 예정
  const credential = utils.cookies.getCredential()?.replace(/ /g, '+')
  const response = await apiRequest(
    commonRequestInstanceToAxiosRequestInfo({
      url,
      method: HTTP_METHOD_POST,
      needCommonParams: true,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${credential}`,
        'wavve-credential': credential,
      },
    }),
    (error) => {
      return { error: { ...error } }
    },
  )
  return response
}
